import { BaseDto } from '@/shared/dtos/base-dto';

export class clients extends BaseDto {
    public name !: string;
    public email !: string;
    public phone !: string;
    public notes !: string;
    public estado_lead !: string;
    public origen !: string;
    public id_comercial_asignado !: number | null;
}
